
import { CalendarPage } from '@/components/calendar/CalendarPage';

/**
 * Página da Agenda
 * 
 * Gerencia agendamentos e consultas da clínica.
 * Esta página encapsula o componente CalendarPage existente
 * para permitir navegação via rotas distintas.
 */
const AgendaPage = () => {
  return <CalendarPage />;
};

export default AgendaPage;
